import type { InputProps as AntInputProps, InputRef } from 'antd';
import { Input as AntInput } from 'antd';
import * as React from 'react';
import { cn } from '@/lib/utils';

export interface InputProps extends Omit<AntInputProps, 'size'> {
  size?: 'default' | 'sm' | 'lg';
}

const sizeMap: Record<'default' | 'sm' | 'lg', AntInputProps['size']> = {
  default: 'middle',
  sm: 'small',
  lg: 'large',
};

const Input = React.forwardRef<InputRef, InputProps>(
  ({ className, type, size = 'default', style, ...props }, ref) => {
    return (
      <AntInput
        ref={ref}
        type={type}
        size={sizeMap[size]}
        className={cn('transition-colors', className)}
        style={{
          boxShadow: 'inset 0 1px 0 var(--card-highlight)',
          ...style,
        }}
        {...props}
      />
    );
  },
);

Input.displayName = 'Input';

// 导出 TextArea 以供需要多行输入的场景使用
const TextArea = AntInput.TextArea;

export { Input, TextArea };
